import MembershipDurationByPackageIdTable from "./pages/MembershipDurationByPackageIdTable";

interface Props {
  package_id: string;
  tableHeader?: string[]
}
const MembershipDurationByPackageId: React.FC<Props> = ({ package_id, tableHeader }) => {
   return (
      <div className="">
       <MembershipDurationByPackageIdTable package_id={package_id}tableHeaders={tableHeader}/>
      </div>
    );
};
export default MembershipDurationByPackageId;
